import { Button, MyIcon } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import { AlertIcon } from '../icons/AlertIcon';
import classes from './WarningMessage.module.scss';

interface IWarningMessageProps {
  entityName: string
  onHighlightFieldClick: () => void;
  onCloseWarningClick: () => void
}
const WarningMessage = ({ entityName, onHighlightFieldClick, onCloseWarningClick }: IWarningMessageProps) => {
  const { t: translate } = useTranslation();

  const handleClick = () => {
    onHighlightFieldClick();
  };
  return (
    <div className={classes.container}>
      <AlertIcon />
      <div className={classes.message}><b>{entityName}</b> {translate('info_message.msg_inactive_warning')} <button type="button" className={classes['link-button']} onClick={handleClick}>{translate('info_message.msg_view_association')}</button></div>
      <Button variant="none" className={classes['btn-close']} onClick={onCloseWarningClick}><MyIcon name="xMarkSmallIcon" /></Button>
    </div>
  );
};

export default WarningMessage;
